export default __webpack_public_path__ + "static/media/sending_livestream.6d9317ca.wav";